/* eslint-disable import/no-named-as-default */
import { store } from 'store';
import { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';
import { SET_CORTE } from 'store/reducers/app';
import API from 'utils/api';

export const baseURI = '/recaudacion/cortes/';

/**
 * POST Abrir Corte
 * @param {object} values
 * @returns {Propmise<boolean>}
 */
export const abrirCorte = async (values) => {
  try {
    const _values = {
      ...values,
      apertura: values?.apertura ? values.apertura.format('YYYY-MM-DD hh:mm:ss') : null,
    };
    const response = await API.post(baseURI, _values);
    onSuccess(response, 'Se ha abierto el corte correctamente');
    store.dispatch({
      type: SET_CORTE,
      payload: formatReceived({
        ...response.data,
      }),

    });
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Abrir Corte
 * @param {number} id
 * @param {object} values
 * @returns {Propmise<boolean>}
 */
export const patchCorte = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Se ha actualizado el corte correctamente');
    store.dispatch({
      type: SET_CORTE,
      payload: formatReceived(response.data),
    });
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST Reabrir Corte
 * @param {number} key
 * @param {object} values
 * @returns {Propmise<boolean>}
 */
export const reabrirCorte = async (key, values) => {
  try {
    const response = await API.post(`${baseURI}${key}/reabrir/`, values);
    onSuccess(response,
      'Se volvió a abrir el corte correctamente, indique al dueño del corte que presione F5');
    store.dispatch({
      type: SET_CORTE,
      payload: formatReceived(response.data),

    });
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Cortes
 * @param {object} params
 * @returns {Promise <object>}
 */
export const getCortes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Registros de recaudacion
 * @param {number} key
 * @returns {pormise<Array<object>>}
 */
export const getRegistrosDeRecaudacion = async (key) => {
  try {
    const response = await API.get(`/recaudacion/cortes/${key}/registros-de-recaudacion/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Cerrar Corte
 * @param {number} key
 * @param {object} values
 * @returns {Promise <boolean>}
 */
export const postCerarCorte = async (key, values) => {
  try {
    const response = await API.post(`/recaudacion/cortes/${key}/cerrar/`, values);
    onSuccess(response, 'El corte ha sido cerrado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
